import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {authQueries, loginUser} from '../services/auth'
import {clearAccessToken, setAccessToken} from '../state/authToken'
import AivatarClient from '../services/AivatarClient'

export default function useAuth() {
    const queryClient = useQueryClient()

    const {
        data: user,
        isLoading,
        error,
    } = useQuery({
        ...authQueries.me,
        retry: false,
        staleTime: 1000 * 60 * 5,
    })

    const loginMutation = useMutation({
        mutationFn: loginUser,
        onSuccess: (data) => {
            setAccessToken(data.accessToken)
            queryClient.setQueryData(authQueries.me.queryKey, data)
        },
    })

    const login = async ({email, password}: { email: string; password: string }) => loginMutation.mutateAsync({
        email,
        password
    })

    const logout = () => {
        clearAccessToken()
        queryClient.setQueryData(authQueries.me.queryKey, null)

        window.location.replace('/login')

        AivatarClient()
            .post('/auth/logout')
            .catch(() => {
                // ignore
            })
    }

    return {
        user,
        isAuthenticated: !!user,
        isLoading,
        error,
        login,
        logout,
    }
}
